import { useState } from "react"
import HikoBreadcrumbs from "../../../utils/HikoBreadcrumbs"
import { createSearchParams, useLocation } from "react-router-dom"
import { useEffect } from "react"
import { hikoGeneratePath } from "@northpowerdev/np-react-utils"

export function DlspBreadcrumbs({assignee, stormArea, suburb, taskAddress, taskICPNumber, assessmentName}) {

    const [trail, setTrail] = useState([])
    const location = useLocation()

    useEffect(() => {
        // console.log('DlspBreadcrumbs useEffect location', location)
        
        if (location?.pathname) {

            const newBreadcrumbs = []

            if (true) {
                const urlString = '/dlsp/list_storm_areas'
                let params = {}
                if (assignee) {
                    params.assignee = assignee 
                }
                const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
                newBreadcrumbs.push({to: path, label: 'All Storm Areas' })
            }

            if (stormArea) {
                const urlString = '/dlsp/storm_area_suburb_list'
                const params = {storm_area: stormArea}
                if (assignee) {
                    params.assignee = assignee 
                }
                const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
                if (location.pathname === urlString) {
                    newBreadcrumbs.push({          label: stormArea })
                } else {
                    newBreadcrumbs.push({to: path, label: stormArea })
                }
            }

            if (stormArea && suburb) {
                const urlString = '/dlsp/suburb_task_list'
                const params = {storm_area: stormArea, suburb: suburb}
                if (assignee) {
                    params.assignee = assignee 
                }
                const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
                if (location.pathname === urlString) {
                    newBreadcrumbs.push({          label: suburb })
                } else {
                    newBreadcrumbs.push({to: path, label: suburb })
                }
            }

            if (stormArea && suburb && taskAddress) {
                const urlString = '/dlsp/task/details'
                const params = {icp_number: taskICPNumber}
                if (assignee) {
                    params.assignee = assignee 
                }
                // const path = generatePath(":urlString?:queryString", { urlString, queryString: createSearchParams(params).toString() });
                const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
                // newBreadcrumbs.push({label: taskAddress }) // ToDo: Add a to: option here.
                if (location.pathname === urlString) {
                    newBreadcrumbs.push({          label: taskAddress })
                } else {
                    newBreadcrumbs.push({to: path, label: taskAddress })
                }
            }

            if (stormArea && suburb && taskAddress && taskICPNumber && assessmentName) {
                //
                // At the moment 'assessments' are the end-of-the-line for DLSP breadcrumbs.
                // We just print the assessment name.
                //
                newBreadcrumbs.push({label: assessmentName })
            }

            setTrail([ ...newBreadcrumbs ])

        }
    }, [location, stormArea, suburb, taskAddress, taskICPNumber, assessmentName, assignee])

    return (
        <HikoBreadcrumbs trail={trail} />
    )
}